import { IFoundTrain, IMenuRaw } from "@framework/provider-asu";

import { IJournalVisualResult, IPrepareData } from "./interfaces";

type TJournalSelectedItem = IMenuRaw | IFoundTrain;

export const getJournalSelectedItemKey = (selectedItem: TJournalSelectedItem): string =>
  "Id" in selectedItem ? `station-${selectedItem.Id}` : `train-${selectedItem.TrainId ?? "unknown"}`;

export const getJournalContextKey = (selectedItem: TJournalSelectedItem, startTime: string, endTime: string): string =>
  `${getJournalSelectedItemKey(selectedItem)}|${startTime}|${endTime}`;

const hasSameJournalContext = (left: IPrepareData, right: IPrepareData | IJournalVisualResult): boolean =>
  getJournalContextKey(left.selectedItem, left.startTime, left.endTime) ===
  getJournalContextKey(right.selectedItem, right.startTime, right.endTime);

export const mergeJournalSnapshot = (
  current: IPrepareData | null,
  next: IPrepareData,
  useNextVisual: boolean,
): IPrepareData => {
  if (useNextVisual) {
    return next;
  }

  return {
    ...next,
    visualJson: current && hasSameJournalContext(current, next) ? current.visualJson ?? [] : [],
  };
};

export const mergeJournalVisualResult = (
  current: IPrepareData | null,
  visualResult: IJournalVisualResult,
): IPrepareData => {
  if (!current || !hasSameJournalContext(current, visualResult)) {
    return visualResult;
  }

  return {
    ...current,
    ...visualResult,
  };
};

export const mergeJournalPage = (
  current: IPrepareData | null,
  page: IPrepareData,
  isStationJournal: boolean,
): IPrepareData => {
  if (!current || !hasSameJournalContext(current, page)) {
    return page;
  }

  return {
    ...page,
    visualJson: current.visualJson ?? page.visualJson,
    trainsJson: isStationJournal
      ? [...(current.trainsJson ?? []), ...(page.trainsJson ?? [])]
      : current.trainsJson ?? page.trainsJson,
    pointsJson: !isStationJournal
      ? [...(current.pointsJson ?? []), ...(page.pointsJson ?? [])]
      : current.pointsJson ?? page.pointsJson,
  };
};
